<template>
  <ReportItemContainer v-if="isReportMode">
    <template #question>{{ question?.text }}</template>
    <template #answer>
      <p>{{ reportViewAnswerText }}</p>
    </template>
  </ReportItemContainer>
  <div v-else>
    <PCheckBox
      style="white-space: pre-line"
      :value="checkboxValue"
      :label="question?.text"
      :help-title="question?.helpTitle"
      :disabled="isReadOnlyMode"
      @value-changed="emitNewValue"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, ref } from "vue";
import ReportItemContainer from "@/components/containers/ReportItemContainer.vue";
import PCheckBox from "@/components/custom/PCheckBox.vue";
import type { QuestionModelDto } from "@/models/dto/questionModelDto";
import { useSelectedQuestionnaire } from "@/stores/selectedQuestionnare";

const props = withDefaults(
  defineProps<{
    questionModel: QuestionModelDto;
    answer?: null | object | boolean;
    error?: string;
    isReportMode?: boolean;
    isReadOnlyMode?: boolean;
  }>(),
  {
    error: "",
    isReportMode: false,
    isReadOnlyMode: false,
  }
);

const emit = defineEmits<{
  (e: "qEvent", newAddress: boolean): void;
  (e: "isValid", isValid: boolean, invalidField: string): void;
}>();

const selectedQuestionnaireStore = useSelectedQuestionnaire();

const checkboxValue = ref((props.answer ?? false) as boolean);
const question = computed(() => props.questionModel?.question);

const reportViewAnswerText = computed((): string =>
  selectedQuestionnaireStore.getTextForAnswerId(
    props.answer?.toString() ?? false.toString(),
    props.questionModel?.question.type!
  )
);

onBeforeMount(() => {
  emitIsValidIfRequired();
});

function emitNewValue(eventValue: boolean): void {
  checkboxValue.value = eventValue;
  emit("qEvent", checkboxValue.value);
  emitIsValidIfRequired();
}

function emitIsValidIfRequired(): void {
  if (props.questionModel.validations.required) {
    emit("isValid", checkboxValue.value, question.value.id);
  }
}
</script>
